import { render, staticRenderFns } from "./SubMenuDesktop.vue?vue&type=template&id=0a31a5de&"
import script from "./SubMenuDesktop.vue?vue&type=script&lang=js&"
export * from "./SubMenuDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports